<template>
    <div class="splash_poem">
        <!-- <img src="./assets/images/hashtag.png"
            class="hashtag" /> -->


        <h6>What does Union of Aries mean?</h6>


        <p>This spring we are taking vows to join as one. Our spirituality, ever-evolving over the past 7 years, has been seeded with esotericism and mysticism. We look inside ourselves for knowing and to nature and the stars for guidance. </p>
        <br />
        <p>On the wheel of the Zodiac, both of us embody the fire signs - Josh is a truth-speaking Sagittarius while Amanda is a Leo, an optimistic perfectionist. These traits have been key elements in our growth as partners. Our passions and ambitions are the fiery forge from which we hope to constantly learn and grow.</p>
        <br />
        <p>Aries is the third and final fire sign of the zodiac. Together, we imagine that we’ve created a third entity between us, a combination of our essences - an independent symbol of our partnership. This vision of our united fiery souls is Aries the Ram, the abundant pioneer. This third entity completes the zodiacal triangle of fire, igniting our union in a trinity of love, magick, and understanding.</p>

        <br />
        <p>&#9651;</p>

        <br />
        <p><a href="https://www.instagram.com/explore/tags/unionofaries/">#unionofaries</a></p>


        <hr />

        <img src="./assets/images/zodiac.png"
            class="zodiac" />
    </div>
</template>

<script>
export default {
    name: 'unionofaries',
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/UnionOfAries.vue